import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { ellipsify } from '../../typography/ellipsify';
import { useTheme } from '../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { BaseUnit } from '../../theming/baseUnitDefinition';

export const CARD_CAPTION_CONTAINER_TYPES = {
  HORIZONTAL: 'horizontal',
  ON_TOP: 'onTop',
  VERTICAL: 'vertical',
  DEFAULT: 'default',
};

interface CardCaptionContainerComponentDataProps {
  numberOfLines: number;
  type: typeof CARD_CAPTION_CONTAINER_TYPES[keyof typeof CARD_CAPTION_CONTAINER_TYPES];
  verticalMarginSmall?: number;
  verticalMarginMedium?: number;
  verticalMarginLarge?: number;
  horizontalMarginSmall?: number;
  horizontalMarginMedium?: number;
  horizontalMarginLarge?: number;
}

interface CardCaptionContainerComponentThemeProps {
  baseUnit: BaseUnit;
}

type CardCaptionContainerComponentProps = CardCaptionContainerComponentDataProps & CardCaptionContainerComponentThemeProps;

const createStyles = ({ baseUnit, horizontalMarginLarge = 0.5, horizontalMarginMedium = 0.5, horizontalMarginSmall = 0.5, verticalMarginLarge = 0.5, verticalMarginMedium = 0.5, verticalMarginSmall = 0.5 }: CardCaptionContainerComponentProps) => StyleSheet.create({
  [CARD_CAPTION_CONTAINER_TYPES.DEFAULT]: {
    overflow: 'hidden',
    width: '-webkit-fill-available',
    [MEDIA_BREAKPOINTS.large]: {
      margin: `${baseUnit * horizontalMarginLarge}px ${baseUnit * verticalMarginLarge}px`,
    },
    [MEDIA_BREAKPOINTS.medium]: {
      margin: `${baseUnit * horizontalMarginMedium}px ${baseUnit * verticalMarginMedium}px`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      margin: `${baseUnit * horizontalMarginSmall}px ${baseUnit * verticalMarginSmall}px`,
    },
  },
  [CARD_CAPTION_CONTAINER_TYPES.ON_TOP]: {
    background: 'transparent',
    position: 'absolute',
    bottom: 0,
  },
  [CARD_CAPTION_CONTAINER_TYPES.HORIZONTAL]: {
    flex: '1 1 66%',
    position: 'relative',
    [MEDIA_BREAKPOINTS.medium]: {
      '-webkitLineClamp': '2',
    },
    [MEDIA_BREAKPOINTS.small]: {
      '-webkitLineClamp': '3',
      flex: '0 0 66.66%',
    },
  },
  [CARD_CAPTION_CONTAINER_TYPES.VERTICAL]: {},
});

export const CardCaptionContainer: React.FunctionComponent<CardCaptionContainerComponentDataProps> = props => {
  const { numberOfLines, children, type } = props;
  const themeProps = useTheme<CardCaptionContainerComponentThemeProps>();
  const cardStyles = createStyles({ ...props, ...themeProps });
  // @ts-ignore TS2345
  const { style } = StyleSheet.create(ellipsify(numberOfLines));

  return (
    <div className={css(
      style,
      cardStyles[CARD_CAPTION_CONTAINER_TYPES.DEFAULT],
      cardStyles[type],
    )}
    >
      {children}
    </div>
  );
};
